module.exports = __webpack_public_path__ + "static/water_glacier19-911fcfcb14f28b70f08dc571a5cf444b.jpg";